import React from 'react';
import { Tooltip } from 'antd';
import { BsPalette, BsChatDots, BsMusicNote, BsTextParagraph, BsStars } from 'react-icons/bs';
import './IconTabBar.css';

const IconTabBar = ({ activeTab, onTabChange, pendingCount = 0, isModerator = false }) => {
    const allTabs = [
        {
            key: 'design',
            icon: <BsPalette />,
            label: 'Design',
            tooltip: 'Design & Branding',
            moderatorOnly: true
        },
        {
            key: 'captions',
            icon: <BsTextParagraph />,
            label: 'Captions',
            tooltip: 'Captions & Banners',
            moderatorOnly: true
        },
        {
            key: 'enhancements',
            icon: <BsStars />,
            label: 'Effects',
            tooltip: 'Media Enhancements',
            moderatorOnly: false  // Available to all participants
        },
        {
            key: 'music',
            icon: <BsMusicNote />,
            label: 'Sound',
            tooltip: 'Sound & Music',
            moderatorOnly: true
        },
        {
            key: 'chat',
            icon: <BsChatDots />,
            label: 'Chat',
            tooltip: 'Live Chat',
            badge: pendingCount > 0 ? pendingCount : null,
            moderatorOnly: false  // Available to all participants
        }
    ];

    // Filter tabs based on moderator status
    const tabs = allTabs.filter(tab => !tab.moderatorOnly || isModerator);

    return (
        <div className="icon-tab-bar">
            {tabs.map(tab => (
                    <div
                        key={tab.key}
                        className={`icon-tab-item ${activeTab === tab.key ? 'active' : ''}`}
                        onClick={() => onTabChange(tab.key)}
                    >
                        <div className="icon-tab-icon">
                            {tab.icon}
                            {tab.badge && (
                                <span className="icon-tab-badge">{tab.badge}</span>
                            )}
                        </div>
                        <div className="icon-tab-label">{tab.label}</div>
                    </div>
            ))}
        </div>
    );
};

export default IconTabBar;
